import MonitorFactory from './MonitorFactory'

export default MonitorFactory
